<style lang="less" scoped>
.table-expand{
  /deep/label {
    width: 90px;
    color: #99a9bf;
  }
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 30%;
  }
}
/deep/.in-dialog{
  &.el-card{
    margin-bottom: 0;
    height: auto;
  }
  img{
    max-width: 100%;
    max-height: 80vh;
    cursor: default;
  }
  .img-item{
    width: 37.5%!important;
    padding: 5px!important;
  }
  .result-item{
    width: 25%!important;
    padding: 15px!important;
  }
  .result{
    height: 190px;
    margin-bottom: 20px;
    font-size: 30px;
    .mode{
      display: block;
      font-size: 20px;
      height: 35px;
      line-height: 35px;
      border-bottom: 1px solid white;
      width: 100%;
    }
    .number{
      flex: 1;
      font-size: 40px;
      justify-content: center;
    }
    .content{
      flex: 1;
      font-size: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .label{
      font-size: 30px;
      height: 45px;
    }
  }
  .el-tag{
    font-size: 20px;
    padding: 10px;
  }
}
</style>

<template>
  <div>
      <el-form inline>
        <el-form-item>
          <el-button-group class="overview-buttons">
            <el-button :class="currentSelect==='all'?  'el-button--primary':''" @click="load('all')">全部</el-button>
            <el-button :class="currentSelect==='today'?'el-button--primary':''" @click="load('today')">今天</el-button>
            <el-button :class="currentSelect==='week'? 'el-button--primary':''" @click="load('week')">本周</el-button>
            <el-button :class="currentSelect==='month'?'el-button--primary':''" @click="load('month')">本月</el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="timeRange"
            value-format="timestamp"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属部门">
          <el-select v-model="pageForm.departmentNo" clearable>
            <el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="执行电脑">
          <el-select v-model="pageForm.computerNo" clearable>
            <el-option v-for="item in pcList" :key="item.id" :label="item.name" :value="item.no"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-table :data="dataList" size="medium">
        <el-table-column type="index" fixed></el-table-column>
        <el-table-column label="服务地址" prop="server" width="155px"></el-table-column>
        <el-table-column label="请求路由" prop="route" width="145px"></el-table-column>
        <el-table-column label="请求IP" prop="caller" width="130px"></el-table-column>
        <el-table-column label="请求电脑">
          <template v-slot="scope">
            {{scope.row.computerNo | computer_name}}
          </template>
        </el-table-column>
        <el-table-column label="所属部门">
          <template v-slot="scope">
            {{scope.row.departmentNo | department_name}}
          </template>
        </el-table-column>

        <el-table-column label="对比类型" width="140px">
          <template v-slot="scope" >
            {{scope.row.route | route_name}}
          </template>
        </el-table-column>
        <el-table-column label="对比模式" width="100px">
          <template v-slot="scope">
            {{scope.row.compareMode.replace("模式","")}}
          </template>
        </el-table-column>
        <el-table-column label="对比结果" width="85px">
          <template v-slot="scope">
            <el-tag type="success" v-if="scope.row.compareResult==='SUCCESS'">
              {{"通过"}}
            </el-tag>
            <el-tag type="danger" v-else>
              <!-- 失败 -->
               {{"未通过"}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="请求时间" width="180px">
          <template v-slot="scope" >
            {{scope.row.createTime | date_time}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100px" fixed="right">
          <template v-slot="scope">
            
            <el-button type="primary" @click="showDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog title="对比详情" :visible.sync="visible" width="90%" destroy-on-close>
        <one-to-video-card :data="currentObject" class="in-dialog"></one-to-video-card>
      </el-dialog>

      <el-pagination style="text-align: center; "
                     :total="total" :layout="'prev, pager, next, jumper, ->, total'"
                     :current-page="pageForm.page + 1"
                     :page-size="pageForm.size"
                     @current-change="pageChange"
      ></el-pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
  import OneToVideoCard from "@/components/1vVcard"
  import moment from "moment";

  export default {
    components: {
      OneToVideoCard
    },
    data() {
      return {
        timeRange: '',
        currentSelect: 'all',
        dataList: [],
        total: 0,
        pageForm: {
          computerNo: '',
          departmentNo: '',
          page: 0,
          size: 20,
          startTime: 946656000, //2000-01-01
          endTime: moment().valueOf(),
          msgCode: ''
        },
        msgList: [],
        loading: false,
        visible: false,
        currentObject: {}
      }
    },
    computed: {
      ...mapState("computer", {pcList: state => state.list}),
      ...mapState("department", {deptList: state => state.list})
    },
    watch: {
      pageForm: {
        handler(v){
          this.loadRecords()
        },
        deep: true
      },
      'pageForm.departmentNo'(v){
        this.pageForm.computerNo = ''
        this.loadPcs(v)
      },
      timeRange (v) {
        if (!v) {
          if(!this.currentSelect){
            this.currentSelect = 'all'
            this.pageForm.startTime = 946656000 //2000-01-01
            this.pageForm.endTime = moment().valueOf()
          }
        } else {
          this.currentSelect = ''
          let [start, end] = v
          this.pageForm.startTime = start
          this.pageForm.endTime = end
        }
      }
    },
    methods: {
      ...mapActions({loadPcs: 'computer/list'}),
      ...mapActions({loadDepts: 'department/list'}),
      load(time){
        //all、today、week、month
        this.currentSelect = time;
        this.timeRange = ''
        if (time==='all') {
          this.pageForm.startTime = 946656000 //2000-01-01
        } else if (time === 'today') {
          this.pageForm.startTime = moment().startOf('date').valueOf()
        } else if (time === 'week') {
          this.pageForm.startTime = moment().startOf('week').valueOf()
        } else if (time === 'month') {
          this.pageForm.startTime = moment().startOf('month').valueOf()
        }
        this.pageForm.endTime = moment().valueOf()
      },
      loadMsg(){
        this.$request(this.$api.record.msglist()).then(res => {
          this.msgList = res
          // console.log(res)
        })
      },
      async loadRecords(){
        this.loading = true;

        let res = await this.$request(this.$api.record.list1vsV(this.pageForm));
        this.dataList = res.list;
        for (let e of res.list) {
          if(e.result[0]==='{'){
            e.result = JSON.parse(e.result);
            if(e.compareImagePairs)
            {
              e.compareImagePairs = JSON.parse(e.compareImagePairs);
            }
          }
        }
        
        this.total = res.total;

        this.loading = false;
        
      },
      showDetail(row){
        this.currentObject = row
        this.visible = true
      },
      pageChange(page) {
        this.pageForm.page = page - 1;
      }
    },
    beforeRouteEnter(to, from, next) {
      if(Vue.store.state.me === null) {
        next(vm => {
          vm.$router.push('login')
        })
      } else {
        let _check = Vue.store.state.me.authorities.map(({ authority }) => authority).includes('admin')
        if(_check){
          next()
        }else{
          next(vm => {
            vm.$router.push('/1vs1/detect')
          })
        }
      }
    },
    mounted() {
      this.loadPcs();
      this.loadDepts();
      this.loadMsg();
      this.loadRecords();
    }
  }
</script>
